import { SESSION_ORIGIN_LABEL } from '@/lib/session-origin';

/**
 * The mark « prod » (vitrine.md section 8.2, issue #192): a small green outlined
 * pill beside the version on a row of the list, on the head of the parcours and of
 * the conversation, and beside the reference of an interview room.
 *
 * One component for the four places that wear it, so they read the same. Green
 * (`vert-deep` outline on white) like the pointer « latest prod » and the mark
 * « en prod » of the versions: the colour of what the production holds. It says
 * the ORIGIN and nothing else - no status, no version.
 */

export interface OriginMarkProps {
  /** The mark a suite reads this pill by; it differs on each screen. */
  readonly testId: string;
}

export function OriginMark({ testId }: OriginMarkProps) {
  return (
    <span
      data-testid={testId}
      data-origin="prod"
      className="inline-flex items-center whitespace-nowrap rounded-sm border border-vert-deep bg-white px-1.5 align-[1px] font-bold text-caption text-vert-deep leading-4"
    >
      {SESSION_ORIGIN_LABEL.prod}
    </span>
  );
}
